import { useEffect } from "react";
import { CTAButton } from "../components/ui-regera/CTAButton";
import { Overline } from "../components/ui-regera/Section";
import { Frame, Head } from "../components/spec/Frame";
import { META_PAGE } from "../data/content";

export default function Metamorphosis() {
  useEffect(() => {
    document.title = "Metamorphosis — REGERA";
  }, []);
  const { intro, steps, engage } = META_PAGE;
  return (
    <div data-testid="metamorphosis-page">
      <Frame id="meta-intro" first>
        <Overline>{intro.overline}</Overline>
        <h1 data-pg-label className="mt-5 font-display font-black text-white tracking-tight leading-none text-[11vw] sm:text-6xl xl:text-7xl break-words">METAMORPHOSIS</h1>
        <p className="mt-4 font-display text-2xl lg:text-3xl font-bold text-[#e60000]">{intro.title}</p>
        <p className="mt-6 text-white/75 text-base lg:text-lg leading-relaxed max-w-3xl">{intro.body}</p>
      </Frame>
      <Frame id="meta-journey" anchor="journey">
        <Head overline="The journey" title="The seven steps." />
        <ol className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-px bg-white/10 border border-white/10">
          {steps.map((s) => (
            <li key={s.n} data-pg-item className="bg-[#0a0a0a] p-5">
              <span className="font-display text-2xl font-black text-[#e60000]">{s.n}</span>
              <h3 className="mt-3 font-display text-lg font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-sm text-white/75 leading-relaxed">{s.text}</p>
            </li>
          ))}
        </ol>
      </Frame>
      <Frame id="meta-engage">
        <Head {...engage} />
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <CTAButton to="/metamorphosis#journey" variant="ghost" testId="metamorphosis-journey-cta">Explore Metamorphosis</CTAButton>
          <CTAButton to={`/contact?area=${encodeURIComponent("Startup & Venture Advisory")}#enquiry`} testId="metamorphosis-engage-cta">Discuss Your Idea</CTAButton>
        </div>
      </Frame>
    </div>
  );
}
